// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  brand: {
    code: 1,
    name: 'coreact',
    logo: './assets/media/logos/coreact-logo-light.png',
  },
  accessLevels: {
    role: 1 || 2 || 3 || 4,
  },
  production: false,
  appVersion: 'v8.1.7',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: true,
  apiUrl: 'api',
  api: 'https://api.stg.coreact.gr/api/',
  analyzeApi: '/analyze-api',
  reportUrl: 'https://reports.api.stg.coassess.gr/',
  imagesServerUrl: 'https://images.dev.coreact.gr/',
  hub: 'https://api.stg.coreact.gr',
  showEthnikiLogo: false,
  neo4jUri: 'bolt+s://neo4j.bolt.dev.coreact.gr:7687',
  neo4jUser: 'neo4j',
  neo4jPass: 'Q7io0Pml1rTu',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
